module.exports = __webpack_public_path__ + "static/media/ic-supplier.c18bb944.svg";